import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { FinancesForm } from 'common/forms';
import { FinancesFormValues } from 'common/models/Forms';

import { QuestionTitle, PageControls } from '../../../../components';
import { selectInvestingFinances, setInvestingFinancesValuesAction } from '../../../../ducks';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function InvestingFinancesFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectInvestingFinances);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } = useFormStepContinueRef<FinancesFormValues>();

  function handleBackClick() {
    navigate(-1);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<FinancesFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: FinancesFormValues) {
    if (!isPrivileged) {
      dispatch(setInvestingFinancesValuesAction(values));
    }
    navigate(`/form/${id}/investing/analyse`);
  }

  return (
    <>
      <QuestionTitle prefix="III.">{t('investingFeature.finances')}</QuestionTitle>
      <FinancesForm bindSubmit={bindSubmit} initialValues={initialValues || undefined} onSubmit={handleSubmit} />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
